import React, { useEffect } from "react";
import SiteContent from "../components/site-items/SiteContent/SiteContent";
import Navbar from "../parts/Navbar/Navbar";
import Footer from "../parts/Footer/Footer";
import PageWrapper from "../components/page-items/PageWrapper/PageWrapper";
import PageHeader from "../components/page-items/PageHeader/PageHeader";
import PageContent from "../components/page-items/PageContent/PageContent";
import { scrollToTop } from "../helpers/helpersFunctions";
import Menu from "../components/buttons/Menu/Menu";
import {
    Categories,
    CategoryBackgroundWrapper,
    CategoryContainer,
    CategoryContainerContent,
} from "../sections/Matches/Matches.styles";
import Category from "../sections/Matches/Category/Category";
import { CategoryInfo } from "../sections/Matches/Category/Category.styles";
import Achievements from "../sections/Achievements/Achievements";
import Tournaments from "../sections/Tournaments/Tournaments";
import MatchHistory from "../sections/MatchHistory/MatchHistory";
import StatisticsContent from "../sections/Statistics/StatisticsContent/StatisticsContent";
import SectionHeader from "../components/section-items/SectionHeader/SectionHeader";
import SectionSubheader from "../components/section-items/SectionSubheader/SectionSubheader";
import SectionBody from "../components/section-items/SectionBody/SectionBody";
import { TEAM_DESCRIPTION } from "../utils/info";

const Competition = () => {
    useEffect(() => {
        scrollToTop();
    }, []);

    return (
        <SiteContent>
            <Navbar />
            <PageWrapper>
                <PageContent paddingBottom={"0px"}>
                    <PageHeader header={"Competition"} />
                    <SectionBody>
                        <SectionHeader>
                            {"Śledź dokonania naszej drużyny"}
                        </SectionHeader>
                        <SectionSubheader>{TEAM_DESCRIPTION}</SectionSubheader>
                        <CategoryContainer url={"stadium.jpg"}>
                            <CategoryBackgroundWrapper>
                                <CategoryContainerContent>
                                    <CategoryInfo>
                                        {"Wskaż interesującą Cię kategorię"}
                                    </CategoryInfo>
                                    <Categories>
                                        <Category type={"achievements"} />
                                        <Category type={"tournaments"} />
                                        <Category type={"matches"} />
                                        <Category type={"statistics"} />
                                    </Categories>
                                </CategoryContainerContent>
                            </CategoryBackgroundWrapper>
                        </CategoryContainer>
                        <Achievements />
                        <Tournaments />
                        <MatchHistory />
                        <StatisticsContent />
                    </SectionBody>
                </PageContent>
            </PageWrapper>
            <Menu />
            <Footer />
        </SiteContent>
    );
};

export default Competition;
